import { render, staticRenderFns } from "./IconPhoto.vue?vue&type=template&id=523c8959&"
import script from "./IconPhoto.vue?vue&type=script&lang=js&"
export * from "./IconPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports